import WidgetButtons from "./WidgetButtons";
import WidgetSpacer from "./WidgetSpacer";
import WidgetBody from "./WidgetBody";
import React, {useState, useEffect, useCallback} from 'react'

const signs = ['aquarius', 'aries', 'cancer', 'capricorn', 'gemini', 'leo', 'libra', 'pisces', 'sagittarius',
    'scorpio', 'taurus', 'virgo'];

const getSignFromPath = () => {

    const getLastItem = thePath => thePath.substring(thePath.lastIndexOf('/') + 1);
    const loc = window.location.pathname.replace(/\/$/, "");
    const signStr = getLastItem(loc) ? getLastItem(loc).toLowerCase() : "";
    console.log("Sign str is:", signStr);
    for (const curSign of signs) {
        if (signStr.indexOf(curSign) >= 0) {
            return curSign;
        }
    }
    return "";
}


const App = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const paramDefault = (name, defaultVal) => {
        if (name in params) {
            return params[name]
        }
        return defaultVal;
    };

    let defaultDate = paramDefault("type", "today");
    switch (defaultDate) {
        case "y":
            defaultDate = "yesterday";
            break;
        case "t":
            defaultDate = "tomorrow";
            break;
        case "n":
            defaultDate = "today";
            break;
    }

    const [date, setDate] = useState(defaultDate);
    const [factor, setFactor] = useState(paramDefault("factor", "regular"))
    const [horoscope, setHoroscope] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    let sign = getSignFromPath();
    if ((!sign || sign === "") && window.HoroWidgetData) {
        sign = window.HoroWidgetData.sign;
    }
    if (sign === "") {
        sign = "gemini"
    }

    useEffect(async () => {
        try {
            setIsLoading(true);
            window.postMessage("factorChanged:" + factor, window.location.href);
            const url = "/wp-json/horo-widget/horoscope?" + new URLSearchParams({
                factor, date, sign
            }).toString();

            const response = await fetch(url);
            const json = await response.json();
            setHoroscope(json.data);
        } catch (error) {
            console.log("error", error);
        } finally {
            setIsLoading(false);
        }

    }, [date, factor, sign])

    const handleFactorChange = useCallback(event => {
        if (event && event.data && typeof event.data === 'string') {
            const chunks = event.data.split(":");
            if (chunks.length > 1) {
                if (chunks[0] === "setFactor") {
                    setFactor(chunks[1]);
                }
            }
        }

    }, []);


    useEffect(() => {
        window.addEventListener('message', handleFactorChange);
        return () => {
            window.removeEventListener('message', handleFactorChange);
        };
    }, [handleFactorChange]);


    return <div>
        <WidgetButtons defaultDate={date} onBtnChange={(date) => {
            setDate(date);
        }}/>

        <WidgetSpacer/>
        <WidgetBody date={date} factor={factor} horoscope={horoscope} isLoading={isLoading}/>
    </div>
}

export default App
